export enum TfaSignInProvider {
  Application = 'Application',
  Email = 'Email',
  Sms = 'SMS',
}
